import "../styles/globalSharedStyles.css";
import "../styles/globals.css";
import { QihHead } from "@/components/common/Head";
import { Footer } from "@/components/common/Footer";
import { AppProps } from "next/app";
import { PageProps } from "@/types/nextjs";
import { Favicons } from "@/components/common/Head/favicons";
import { Analytics } from "@/components/common/Analytics";
import { CookiePolicy } from "@/components/common/CookiePolicy";
import { SessionProvider } from "next-auth/react";
import type { Session } from "next-auth";
import { fonts } from "@/utils/fonts";

import "./../../logging/datadog-init";
import PageContextProvider from "@/contexts/PageContext";
import { PageContextSchema } from "@/contexts/PageContext/schema";

type ServerSideProps = {
    page: PageContextSchema;
};

const App = ({
    Component,
    pageProps: { session, ...pageProps },
}: AppProps<PageProps & ServerSideProps & { session: Session }>) => {
    const { site, siteTheme, pageData } = pageProps;
    return (
        <SessionProvider session={session}>
            <PageContextProvider data={pageData?.page}>
                <QihHead
                    site={site}
                    siteTheme={siteTheme}
                    pageData={pageData}
                />
                <style jsx global>{`
                    html {
                        font-family: ${fonts.saira.style.fontFamily};
                    }
                    :root {
                        --font-saira: ${fonts.saira.style.fontFamily};
                        --font-roboto-flex: ${fonts.robotoFlex.style
                            .fontFamily};
                        --font-plus-jakarta-sans: ${fonts.plusJakartaSans.style
                            .fontFamily};
                        --font-font-awesome: ${fonts.fontAwesome.style
                            .fontFamily};
                    }
                `}</style>
                <Favicons {...pageProps} />
                <Analytics {...pageProps} />
                <Component {...pageProps} />
                <Footer site={pageProps.site} />
                {pageProps?.site?.attributes?.sanitisedCookiePolicyText ? (
                    <CookiePolicy
                        autoDismiss={
                            pageProps.site?.attributes
                                ?.dismissCookiePolicyOnNavigation ?? false
                        }
                        cookiePolicyText={
                            pageProps.site?.attributes
                                ?.sanitisedCookiePolicyText ?? ""
                        }
                    />
                ) : null}
            </PageContextProvider>
        </SessionProvider>
    );
};

export default App;
